import { render } from "./ListaSinistrosCobrancaView.vue?vue&type=template&id=87d5151e&scoped=true"
import script from "./ListaSinistrosCobrancaView.vue?vue&type=script&lang=js"
export * from "./ListaSinistrosCobrancaView.vue?vue&type=script&lang=js"

import "./ListaSinistrosCobrancaView.vue?vue&type=style&index=0&id=87d5151e&scoped=true&lang=css"

import exportComponent from "C:\\Users\\LAF\\Desktop\\GARANTEPAY\\PROJETOS\\WORKFLOW\\FrontVue-main\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87d5151e"]])

export default __exports__